/** CylinderMesh resource slice: claims the type name, re-exports its decode. */
import { registerGenericResourceSlice } from '../../sliceRegistration.js';
registerGenericResourceSlice('cylindermesh', ['CylinderMesh']);
//# sourceMappingURL=index.js.map